<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted } from 'vue';

import type { FlashMessageItemProps } from '@shop/components/ui/FlashMessageItem.types';

const props = withDefaults(defineProps<FlashMessageItemProps>(), {
  timeout: 10000,
});

const emit = defineEmits<{
  dismiss: [id: number];
}>();

const icon = computed(() => {
  if (props.level === 'success') {
    return 'check';
  }
  if (props.level === 'warning') {
    return 'search';
  }
  return 'cancel';
});

let timer: ReturnType<typeof setTimeout> | undefined;

onMounted(() => {
  if (props.timeout > 0) {
    timer = setTimeout(() => {
      emit('dismiss', props.id);
    }, props.timeout);
  }
});

onBeforeUnmount(() => {
  if (timer !== undefined) {
    clearTimeout(timer);
  }
});
</script>

<template>
  <span class="flashmessage__message" :class="`flashmessage__message--${level}`">
    <i class="icon icon--showleft" :class="`icon--${icon}`"></i>
    <span>{{ message }}</span>
  </span>
</template>
